




































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderPayFailGrids from '@/components/order/mixins/OrderPayFailGrids';

import {Component, Mixins, Ref} from 'vue-property-decorator';
import {ncpPopup} from '@/utils/commonUtils';
import $ from 'jquery';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable}
})
export default class OrderList extends Mixins(OrderPayFailGrids, OrderGridBrokenFreeGiftMixin) {
	@Ref('gridBottom')
	private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeHelpData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: true
  };
  private searchDateTypeArr: any[] = [
    {
      value: 'ORDER_YMDT',
      name: '주문일시'
    }
  ];
  private created(): void {}
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }

  private initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.theExcelDownIfo.columns = [];
    columns.forEach((el: any): any => {
      this.theExcelDownIfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.theExcelDownIfo.formatters = this.excelDownInfo.formatters;
    this.theExcelDownIfo.fileName = 'order_';
  }
  private handleSearch(e: any, page: number = 1, size: number): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.search(page, size);
  }
  private handleCancel(): void {}
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'PAY_FAIL';
    this.request.params.page = page;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
        .getOrderOptionsOrderGrid(this.request)
        .then((res) => {
          this.orderListContent = [];
          let content: any = res.data.contents;
          if (res.data.contents.length > 0) {
            this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
            let bigRow = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo', 'procBtn', 'failInfo'];
            let midRow = [
              'receiverName',
              'receiverContact1',
              'receiverZipCd',
              'address',
              'shippingNo',
              'deliveryMemo',
              'customsIdNumber',
              'deliveryType',
              'deliveryCompanyType',
              'invoiceNo',
              'deliveryAmtInAdvanceYn',
              'adjustedAmt',
              'remoteDeliveryAmt',
              'lastSubPayAmt',
              'lastMainPayAmt',
            ];
            let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	          const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		          small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	          }

            this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
          }
          this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
          this.totalCount = res.data.totalCount;
          this.gridProps.options.pageOptions.page = page;
          this.gridProps.options.pageOptions.perPage = this.size;
          this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
        })
        .finally((): any => {
          $('#loading').hide();
        });
  }
  private contentBottomOption: any = {
    name: 'benefit_list',
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    autoHeight: false,
    excelDownInfo: this.theExcelDownIfo
  };
}
